import React from 'react';

import Vulnerability from '../../types/Vulnerability';
import styles from './vulnerabilitiesList.scss';

type Props = {
  id: string;
  vulnerabilities: Vulnerability[];
  currentVulnerabilityId: string | null;
  onClickVulnerability: (vulnerability: Vulnerability) => void;
};

const VulnerabilitiesList: React.FC<Props> = (props) => {
  const renderList = () => {
    // Map the vulnerabilities list to list items.
    const list = props.vulnerabilities.map((vulnerability, index) => {
      return (
        <li
          key={index}
          onClick={() => props.onClickVulnerability(vulnerability)}
          className={vulnerability.uuid === props.currentVulnerabilityId ? styles['current'] : null}
        >
          {vulnerability.name}
        </li>
      );
    });

    return list;
  };

  return (
    <div id={props.id} data-testid={props.id} className={styles['vulnerabilities-list']}>
      <h1>Vulnerabilities:</h1>

      <div className={styles['list-container']}>
        <ul>{renderList()}</ul>
      </div>
    </div>
  );
};

export default VulnerabilitiesList;
